module.exports = __webpack_public_path__ + "static/gallery4-ad35cbd2221690a119534558b0547cd0.jpg";